export const MEDICAL_REPORT_API_VERSION = {
  OLD: 1,
  NEW: 2,
};
